module.exports = function() {
  return new Worker(__webpack_public_path__ + "88e77a25b6bbf5642382.worker.js");
};